import React from "react";
import dartsImg from 'tournament/static/tournament/image/darts.svg'
import {ReactComponent as ChevronLeft} from 'championship/static/championship/icon/feather/chevron-left.svg'
import {ReactComponent as ChevronRight} from 'championship/static/championship/icon/feather/chevron-right.svg'

import './style.css'

class EmptyState extends React.Component {
  render() {
    return (
      <div className='empty-state'>
        <img src={dartsImg} alt="darts" className="empty-state__icon"/>
        <div className="empty-state__text">
          {this.props.text || gettext('Нет турниров')}
        </div>
        <div className="empty-state__history">
          {this.props.prev && (
            <div className="empty-state__prev">
              <button className='empty-state__btn' onClick={this.props.prev}>
                <ChevronLeft/>
              </button>
              {gettext('Прошлый день')}
            </div>
          )}
          <div className="empty-state__hr"></div>
          {this.props.next && (
            <div className="empty-state__next">
              {gettext('Следующий день')}
              <button className='empty-state__btn' onClick={this.props.next}>
                <ChevronRight/>
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default EmptyState